<template>
    <v-layout justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Detalles del Plan</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-select
                                        :items="subscription_types"
                                        v-model="subscription"
                                        filled
                                        label="Tipo de cuenta"
                                        dense
                                ></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                        v-model="pos_points"
                                        label="Puntos de posicionamiento"
                                        filled
                                        :disabled="disabled"
                                        type="number"
                                        min="0"
                                        max="9999"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-switch :disabled="disabled || loading" v-model="subscription_paused" label="Suspender Cuenta" :value="subscription_paused"></v-switch>
                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="hideDialog">Cancelar</v-btn>
                    <v-btn color="primary" :disabled="loading || disabled" :loading="loading" text @click="update">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        data(){
            return {
                loading: false,
                disabled: true,
                id: null,
                dialog: false,
                subscription_type: "free",
                subscription_paused: 0,
                pos_points: 0,
                subscription_types: ['free', 'premium'],
                created_at: null
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            async showDialog(providerId){

                var vm = this
                vm.dialog = true
                vm.reset()

                vm.disabled = true
                const response = await ApiUtils.makeGet(`provider/${providerId}/account`)

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ocurrio un error consultando la cuenta')
                    vm.disabled = true
                    return
                }

                const json = await response.json()
                vm.id  = json.result.provider.id
                vm.subscription_type= json.result.provider.subscription_type
                vm.subscription_paused= json.result.provider.subscription_paused
                vm.pos_points= json.result.provider.pos_points
                vm.created_at= json.result.provider.created_at
                vm.disabled = false

            },
            hideDialog(){
              this.dialog = false
            },
            async update(){
                var vm = this
                vm.loading = true
                const response = await ApiUtils.makePatch(`provider/${vm.id}/account`, null, {
                    subscription_type: vm.subscription_type,
                    subscription_paused: vm.subscription_paused ? 1 : 0,
                    pos_points: vm.pos_points
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar((json.result.pos_points ? json.result.pos_points[0] : json.message) || 'Ocurrio un error actualizando la cuenta')
                    return
                }

                vm.$emit('success')
                vm.hideDialog()
            },
            reset(){
                var vm = this
                vm.id  = null
                vm.subscription_type= 'free'
                vm.subscription_paused=0
                vm.pos_points= 0
                vm.created_at = null
            }
        }
    }
</script>